/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, SortDirection, Sorting } from 'app/shared/lib/essette-site';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';
import { localSort } from 'app/shared/lib/sorting';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class ResourcesGridCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    private sorting: Sorting = new Sorting();
    private defaultSorting: Sorting = new Sorting();

    @bindable.object()
    protected resources!: Core.Resource[];

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);

        this.defaultSorting.entries = [{
            reference: 'description',
            direction: SortDirection.Ascending
        }];
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting: sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        if(this.sorting.entries.length == 0) {
            localSort(this.resources, this.defaultSorting);
        }
        localSort(this.resources, sorting);
    }

    ////****************** Service Calls ********************************************////

}
